import { ReactNode } from 'react';
import { usePageTracking } from '../hooks/useAppInsightsTracking';

interface Props {
  children: ReactNode;
}

export default function AppInsightsRouteTracker({ children }: Props) {
  usePageTracking();
  return <>{children}</>;
}
